import React, { ChangeEvent, useEffect, useState } from 'react';

interface DatepickerInputProps {
  selectedDate: number; // Unix timestamp (in seconds)
  onDateChange: (newValue: number) => void; // Return timestamp (in seconds)
  placeholder?: string;
}

export const DatepickerInput: React.FC<DatepickerInputProps> = ({
  selectedDate,
  onDateChange,
  placeholder = 'Select Date and Time',
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [localValue, setLocalValue] = useState('');

  // Convert timestamp to datetime-local format
  const toLocalInputValue = (timestamp: number) => {
    const date = new Date(timestamp * 1000); // seconds to ms
    return date.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
  };

  // Convert input value back to timestamp
  const toUnixTimestamp = (value: string) => {
    return Math.floor(new Date(value).getTime() / 1000); // ms to seconds
  };

  useEffect(() => {
    if (selectedDate) {
      setLocalValue(toLocalInputValue(selectedDate));
      setIsFocused(true);
    }
  }, [selectedDate]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setLocalValue(value);
    onDateChange(toUnixTimestamp(value));
  };

  return (
    <div className='w-full relative'>
      <input
          type='datetime-local'
          value={localValue}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            if (!localValue) setIsFocused(false);
          }}
          placeholder={placeholder}
          className='w-full p-2 border border-gray-300 rounded-md outline-none transition-all duration-200
                   focus:border-transparent focus:ring-2 focus:ring-primary-main/50 focus:shadow-sm
                   peer'
      />
      <label
          htmlFor='datetime-local'
          className={`absolute text-sm transition-all bg-white px-1 duration-200 ${
            isFocused || localValue
              ? 'top-0 left-2 text-primary-main'
              : 'top-1/2 left-2 text-gray-500'
          } transform -translate-y-1/2 peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-gray-500`}
      >
        { placeholder }
      </label>
    </div>
  );
};
